import { render } from "./Portal.vue?vue&type=template&id=645f9b43&ts=true&lang=pug"
import script from "./Portal.vue?vue&type=script&lang=ts"
export * from "./Portal.vue?vue&type=script&lang=ts"

import "./Portal.vue?vue&type=style&index=0&id=645f9b43&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__